var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('barcode-scanner',{attrs:{"enabled":_vm.enabled},on:{"input":_vm.searchByBarcode,"change":_vm.changeEnableScanner},model:{value:(_vm.enabledScanner),callback:function ($$v) {_vm.enabledScanner=$$v},expression:"enabledScanner"}})}
var staticRenderFns = []

export { render, staticRenderFns }